/* IMPORT HERE */

import { ThemeUICSSObject } from 'theme-ui';

export const switchCard: ThemeUICSSObject = {
  '&.switch__card': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    borderBottom: '1px solid',
    borderColor: 'palette.border.field',
    p: 4,
    '.label__container': {
      display: 'flex',
      flexDirection: 'row',
      gap: 3,
      alignItems: 'center',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      span: {
        flexShrink: 0,
      },
    },
    '.switch__container': {
      display: 'flex',
      flexDirection: 'row',
      gap: 3,
      alignItems: 'center',
      '& label': {
        height: '21px',
      },
      input: {
        display: 'none',
      },
    },
  },

  /* PREPEND HERE */
};
